<div class="container">
    <form class="page initial-state justify-center">
        <h1 class="title">Gracias por registrate!</h1>
        <div class="page-box">
            <div class="page-form-control" *ngIf="authService.userData as user">
                <p class="text-center">Acabamos de enviar un mail a <strong>{{user?.email}}</strong>.</p>
                <p class="text-center">Por favor chequea tu correo y haz click en el link para verificar tu cuenta.</p>
            </div>
            <button mat-raised-button color="primary" class="page-button" (click)="authService.sendVerificationMail()">Reenviar verificación</button>
            <span class="page-text">
                ¿Quieres volver?
                <div class="page-link" routerLink="/sign-in">Loguearme</div>
            </span>
        </div>
    </form>
    <img src="assets/safaera_login_image.jpg"  class="login-image" alt="a man in a concert doing rock signs">

</div>